import React, {useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useObservable} from '@ngneat/react-rxjs';
import {finalize} from 'rxjs';
import {useSnackbar} from 'notistack';

import {supplierDetailsQuery} from '@store/suppliers/details';
import {suppliersServicesQuery, suppliersServicesService} from '@store/suppliers/services';

import {Add, Download, GroupAction} from '@icons/index';

import SupplierCatalogTable from '@screens/admin/suppliers/details/catalog/SupplierCatalog.table';

const SupplierCatalogTab = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {enqueueSnackbar} = useSnackbar();

  const [CSVLoading, setCSVLoading] = useState(false);

  const [selectedSupplierServices] = useObservable(suppliersServicesQuery.selectedSuppliersServices$);

  const handleExportCSV = () => {
    setCSVLoading(true);
    suppliersServicesService.getSuppliersServicesCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} mt="-35px" spacing={2}>
      <Stack direction="row" alignItems="center" justifyContent="flex-end">
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button
            variant="outlined" color="primary"
            startIcon={<GroupAction/>}
            disabled={!selectedSupplierServices.length}>
            {t('global.groupedAction')}
          </Button>
          <Button
            variant="outlined" color="primary"
            disabled={CSVLoading}
            onClick={handleExportCSV}
            startIcon={<Download/>}>
            {t('global.exportCSV')}
          </Button>
        </Stack>
      </Stack>
      <SupplierCatalogTable/>
    </Stack>
  );
};

export default SupplierCatalogTab;
